import { apiCall } from '../services/apiUtil';
import { secureStorage } from '../services/secureStorage';

// secureStorage stores 'socialUser' as JSON on native (Capacitor Preferences)
// and falls back to localStorage on web — use it instead of localStorage directly.
async function getCurrentUserId() {
  const raw = await secureStorage.getItem('socialUser');
  if (!raw) return null;
  try {
    return JSON.parse(raw)?.id ?? null;
  } catch {
    return null;
  }
}

/**
 * Notification Service
 *
 * Handles reading and managing notifications from the exsports_fastify_api.
 * Note: Sending notifications is handled by the backend (Graph API -> Fastify API).
 */
export const notificationService = {
  async getNotifications({ unreadOnly = false, priority = null, limit = 10, offset = 0 } = {}) {
    try {
      const userId = await getCurrentUserId();
      if (!userId) return { success: false, error: 'Not authenticated' };

      const params = new URLSearchParams();
      if (unreadOnly) params.append('status', 'unread');
      if (priority) params.append('priority', priority);
      params.append('limit', limit);
      params.append('offset', offset);

      const data = await apiCall(`/users/${userId}/notifications?${params.toString()}`);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching notifications:', error);
      return { success: false, error: error.message };
    }
  },

  async getUnreadCount() {
    try {
      const userId = await getCurrentUserId();
      if (!userId) return { success: false, error: 'Not authenticated' };

      const data = await apiCall(`/users/${userId}/notifications/unread-count`);
      return { success: true, data };
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return { success: false, error: error.message };
    }
  },

  async markAsRead(notificationId) {
    try {
      const data = await apiCall(`/notifications/${notificationId}/mark-read`, {
        method: 'PATCH',
        body: JSON.stringify({}),
      });
      return { success: true, data };
    } catch (error) {
      console.error('Error marking notification as read:', error);
      return { success: false, error: error.message };
    }
  },

  async markAllAsRead() {
    try {
      const userId = await getCurrentUserId();
      if (!userId) return { success: false, error: 'Not authenticated' };

      const data = await apiCall(`/users/${userId}/notifications/mark-all-read`, {
        method: 'PATCH',
        body: JSON.stringify({}),
      });
      return { success: true, data };
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      return { success: false, error: error.message };
    }
  },
};

export default notificationService;
